var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBagnallSoftwareBrConsultantsLtd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1835,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    width: 1.5,
    height: 1.5,
    x: -0.25,
    y: -0.25
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.3,
    in: "SourceAlpha",
    result: "result91"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "result91",
    operator: "out",
    in: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "result0",
    stdDeviation: 1.2
  }), /*#__PURE__*/React.createElement("feDiffuseLighting", {
    result: "result92"
  }, /*#__PURE__*/React.createElement("feDistantLight", {
    elevation: 66,
    azimuth: 225
  })), /*#__PURE__*/React.createElement("feBlend", {
    in2: "SourceGraphic",
    mode: "multiply",
    result: "result93"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "fbSourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "fbSourceGraphicAlpha",
    stdDeviation: 20,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "bluralpha",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "bluralpha",
    dx: 10,
    dy: 20,
    result: "offsetBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offsetBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "fbSourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    width: 1.5,
    height: 1.5,
    x: -0.25,
    y: -0.25
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.3,
    in: "SourceAlpha",
    result: "result91"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "result91",
    operator: "out",
    in: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "result0",
    stdDeviation: 1.2
  }), /*#__PURE__*/React.createElement("feDiffuseLighting", {
    result: "result92"
  }, /*#__PURE__*/React.createElement("feDistantLight", {
    elevation: 66,
    azimuth: 225
  })), /*#__PURE__*/React.createElement("feBlend", {
    in2: "SourceGraphic",
    mode: "multiply",
    result: "result93"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "fbSourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "fbSourceGraphicAlpha",
    stdDeviation: 20,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "bluralpha",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "bluralpha",
    dx: 10,
    dy: 20,
    result: "offsetBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offsetBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "fbSourceGraphic"
  }))))), /*#__PURE__*/React.createElement("g", {
    fontSize: 40,
    fontWeight: 400,
    letterSpacing: 0,
    wordSpacing: 0,
    fill: "#0000bc",
    fontFamily: "Sans"
  }, /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: "124.00000095%"
    },
    x: -1137.993,
    y: 750.81,
    transform: "translate(1054.033 -391.681) scale(.84987)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1137.993,
    y: 750.81,
    style: {
      InkscapeFontSpecification: "Arial Bold"
    },
    fontSize: 240,
    fontWeight: 700,
    fontFamily: "Arial"
  }, " Bagnall Software"), /*#__PURE__*/React.createElement("tspan", {
    x: -1137.993,
    y: 1048.41,
    style: {
      InkscapeFontSpecification: "Arial Bold"
    },
    fontSize: 240,
    fontWeight: 700,
    fontFamily: "Arial"
  }, "Consultants")), /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: "124.00000095%"
    },
    x: -1137.993,
    y: 750.81,
    transform: "translate(2395.146 -138.091) scale(.84987)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1137.993,
    y: 750.81,
    style: {
      InkscapeFontSpecification: "Arial Bold"
    },
    fontSize: 240,
    fontWeight: 700,
    fontFamily: "Arial"
  }, "Ltd "))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagnallSoftwareBrConsultantsLtd);
export default __webpack_public_path__ + "static/media/bagnall-software-br-consultants-ltd.c181c402ff2716eb598e6a3dcf0dee63.svg";
export { ForwardRef as ReactComponent };